<template>
    <div class="aviso" ref="aviso" >
        <div class="container">
            <div  style="max-width: 1000px; justify-self: center;">
                <h1>Aviso de Privacidad Integral.</h1>
                <div class="d-flex justify-content-end pt-3">
                    <p class="politicas-parrafo">ÚLTIMA ACTUALIZACIÓN: 1 DE ENERO DE 2023</p>
                </div>
                <p class="politicas-parrafo">
                    En cumplimiento con la <strong>Ley Federal de Protección de Datos Personales en Posesión de los Particulares</strong> (LFPDPPP), 
                    su Reglamento, y los <strong>Lineamientos del Aviso de Privacidad</strong> publicados en el Diario Oficial de 
                    la Federación, <strong>ALS LOGINUN S.A. DE C.V.</strong> (“Cliker”), con domicilio en <strong>Calle 4 Diag. 170, Piso 8 Int. 811, Col. 
                    Montecristo, Mérida Yucatán,</strong> en su calidad de responsable del tratamiento de los datos personales recabados, 
                    pone a disposición de sus clientes y usuarios de plataformas digitales (cada uno de ellos, el “Titular”) el 
                    siguiente Aviso de Privacidad (el “Aviso”).
                </p>
                <div class="politicas mt-4">
                    <div v-for="politica in datapoliticas" :value="politica.value" :key="politica.value">
                        <!-- <span class="politicas-span">{{politica.orden}} - {{politica.titulo}}</span> -->
                        <span class="politicas-span">{{politica.titulo}}</span>
                        <p class="politicas-parrafo" v-html="politica.descripcion"></p>
                        <br>
                    </div>
                </div>
            </div>
            
            <h2>Solicita tu demostración</h2>
            <b-button pill size="sm" class="btnDemo"  to="/home" @click="linkContact()" type="submit">Recibir demo</b-button>
        </div>
    </div>
</template>
<script>
// @ is an alias to /src

import politicasApi from "../api/politicas";

export default {
  name: 'aviso',
  components: {

  },
  data(){
      return {
          datapoliticas: []
      }
  },
  methods: {
    linkContact(){
      setTimeout(function(){ window.location = "/home#contacto"; },100);
    },
    refname(refname) {
        this.$router.push("/");
    },
    getPoliticas(){
      politicasApi
      .getPoliticas()
      .then(response => {
        this.datapoliticas = response.data.data;
      }).catch(err => {
        console.log("Ocurrio un error al cargar las politicas.");
      });
        
    }
  },
  mounted(){
      this.getPoliticas();
  },
  created () {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  },
}
</script>
<style scoped>
h1{
  font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 38px;
    line-height: 38px;
    align-items: center;
    text-align: center;
    letter-spacing: 0.2px;
    color: #1E2144;
}

h2{
    font-family: Muli-extrabold;
    font-style: normal;
    font-weight: 800;
    font-size: 38px;
    line-height: 38px;
    align-items: center;
    text-align: center;
    letter-spacing: 0.2px;
    color: #1E2144;
}

.politicas{
    
    margin-top:100px;
    margin-bottom:100px;
    text-align: left;
}

.politicas-parrafo{
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 25px;
    letter-spacing: 0.2px;
    color: #1E2144;
    padding-top:20px;
    text-align: left;
}

.politicas-span{
    font-family: Muli;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 25px;
    letter-spacing: 0.2px;
    color: #1E2144;
}

.btnDemo {
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    padding: 13px 27px;
    color: #FFF ;
    background: #2DB9D1;
    border-color: #2DB9D1;
    border-radius: 18px;
    margin-top:60px;
    margin-bottom:100px;
}
.btnDemo:hover{
    color: #FFFFFF;
    background-color: #4F4C4C;
    border-color: #4d4c4f !important;
}
</style>